module.exports = __webpack_public_path__ + "img/switzerland-eye-and-ear-diseases-female.1cae31c0.png";